<template>
    <div v-html="helpText"></div>
</template>

<script>
export default {
    props: ["helpText", "item", "field"]
}
</script>